(function($) {
    $.GPSSimulator = function(options) {
        this._component_name = "gps_simulator";
        this._options = options || {};
        this._coordinates = { default: [] };
        this._default_location = 'default';
        this._current_coordinates = this._coordinates[this._default_location]; 

        this._simulator = null;

        this._events = {
            ready: "ready",
        };
        
        $.Component.call(this, $.GPSSimulator);
        // this._on('ready', $.Component.bind(this, $.GPSSimulator));
        // this._on('ready', function(){
        //     console.log("simulation module ready");
        // });
    };

    $.Component.create($.GPSSimulator, {
        _init: function(options) {
            this._options = options || {};
            this._buttons_container = this._options.buttons_container || '#buttons-overlay > .buttons-container';

            if (typeof(this._buttons_container) === 'string') {
                this._buttons_container = document.querySelector(this._buttons_container);
            }

            var paramsString = window.location.search || '';
            var searchParams = new URLSearchParams(paramsString); 
            
            if (searchParams.has('testgps') || (
                typeof(enable_test_gps) !== 'undefined' && enable_test_gps)) {
                var location = 'default';
                var speed = 40; 
        
                if (searchParams.has('location')) {
                    location = searchParams.get('location');
                }
                if (searchParams.has('speed')) {
                    speed = parseInt(searchParams.get('speed'));
                } 
        
                var repeat = false;
                if(searchParams.has('repeat')) {
                    repeat = true;
                }

                var path_button = false;
                if (searchParams.has('path_button')) {
                    path_button = true;
                }
                
                this._initialize_simulation(location, speed, repeat, path_button);    
            }

            if (searchParams.has('max-accuracy')) {
                var max_accuracy = parseFloat(searchParams.get('max-accuracy'));
                var btnStartTracking = document.getElementById('btnStartTracking');
                if (btnStartTracking != null) {
                    btnStartTracking.dataset.maxAccuracy = max_accuracy;
                }
            }
        },

        btnStartSimulationClicked: function(location, speed, repeat, evt) { 
            this._enable_scroll = true;
            
            if (typeof(this.parent.history) !== 'undefined') {
                this.parent.history._clear();
                this.parent.history._hide();
            }
    
            if (this._simulator == null) {
                this.parent.resetTracking();
    
                this._simulator = $.GeoSim(
                    {
                        coords: this._current_coordinates, 
                        speed: speed, 
                        onsimulationfinished: this._on_simulaton_finished.bind(this),
                        tracker: this.parent,
                        repeat: repeat
                    });
    
                this._simulator.start();
                this.parent.btnStartTrackingClick();
                console.log('シムレーションが開始しました');
            }
            else {
                this.parent.resetTracking(this._hide_history.bind(this));
                this._simulator.restore();
                this._simulator = null;
                console.log('シムレーションが中止しました');
            }
        },

        _on_simulaton_finished: function() {
            this.parent.resetTracking(this._hide_history.bind(this));
            this._simulator = null;
        },

        // todo move functionality to tracking_history.js
        _hide_history: function() { 
            if (typeof(this.parent.history) !== 'undefined') {
                this.parent.history._hide();
            }
        },

        _simulation_loaded: function(location, speed, repeat, path_button) { 
            this._current_coordinates = this._coordinates[location];
            if (typeof(this._coordinates[location]) === 'undefined') {
                alert(location + 'のシムレーションデータが存在しないから' + this._default_location + 'のデータを使わせていただきます');
                console.log(this._default_location+'のシムレーションデータを使っています');
            }
            else {
                this._current_coordinates = this._coordinates[location];
                console.log(location + 'のシムレーションデータを使っています');
            }
    
            console.log('GPSのシムレーションのスクリプトが読み込まれた'); 
     
            // select first immediate children of #buttons-overlay as a container  
            if(this._buttons_container) {
                var btnStartSimulation = document.createElement('button');
                btnStartSimulation.innerText = 'GPSテスト';
                btnStartSimulation.dataset.langkey = 'GPSテスト';
                btnStartSimulation.classList.add('btn_style_1','transition');
                this._buttons_container.prepend(btnStartSimulation); 
                
                btnStartSimulation.addEventListener(
                    ABDOUtil.getClickHandler(btnStartSimulation), 
                    this.btnStartSimulationClicked.bind(this, location, speed, repeat));

    
                if (path_button) {
                    var btnShow = document.createElement('button');
                    btnShow.innerText = 'GPSパス';
                    btnShow.dataset.langkey = 'GPSパス';
                    btnShow.classList.add('btn_style_1');
                    this._buttons_container.prepend(btnShow);
                    btnShow.addEventListener(
                        ABDOUtil.getClickHandler(btnShow), this._btn_show_click.bind(this)); 
                }
            }

            this._emit('ready');
        },

        _btn_show_click: function() {
            if (this._simulator == null) {
                alert('シミュレーションがまだ始まっていない');
                return;
            }
            this._simulator.toggleGPSRoute();
        },

        _initialize_simulation: function(location, speed, repeat, path_button) {
            // if (typeof($.GeoSim) === 'undefined') {
            //     var script = document.createElement('script');
            //     script.addEventListener('load', 
            //         this._simulation_loaded.bind(this, location, speed, repeat, path_button));
            //     script.src = '_abdo_location_simulator/js/geolocation-simulator.js'; 
            //     document.body.appendChild(script);
            // }
            // else {
            //     this._simulation_loaded(location, speed, repeat, path_button);
            // }
            this._simulation_loaded(location, speed, repeat, path_button);
        },

        _on_script_load: function() {
            this._simulation_loaded.call(self, location, speed, repeat, path_button); 
        },

        addSimulationData: function(name, data) {
            this._coordinates[name] = data;
        },

        setSimulationData: function(name) {
            if (name in this._coordinates) {
                this._current_coordinates = this._coordinates[name];
            }
        }, 

    }, $.Tracker);
 
}(ABDOMap));